/** Cookie categories for OneTrust. */
export const CookieCategories = {
  PERFORMANCE: 'C0002',
  TARGETING: 'C0004'
} as const;
